(function() { window.GUID_fe0df3da_b738_45be_9a22_cb488b988c06 = { getGuid: function() { return "fe0df3da-b738-45be-9a22-cb488b988c06"; } }; })();
//namespace CS.Controls {
//    export class GraphStats extends Graph {
//        constructor(controlId: string) {
//            super(controlId);
//            //Here the graph is initialised
//        }
//    }
//    export namespace GraphStats {
//        export class Events extends Graph.Events {
//        }
//        export class EventNames extends Graph.EventNames {
//        }
//    }
//    import that = GraphStats;
//}

//# sourceMappingURL=graph-stats.js.map
